import { render, staticRenderFns } from "./indica-check-box.vue?vue&type=template&id=b5110b44&scoped=true&"
import script from "./indica-check-box.vue?vue&type=script&lang=js&"
export * from "./indica-check-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5110b44",
  null
  
)

export default component.exports